export const LOADER_INDIKATORS            =     "LOADER_INDIKATORS";
export const LOADER_INDIKATOR             =     "LOADER_INDIKATOR";
export const SAVE_LOADER_INDIKATOR        =     "SAVE_LOADER_INDIKATOR";
export const GET_INDIKATORS               =     "GET_INDIKATORS";
export const GET_INDIKATOR                =     "GET_INDIKATOR";
export const FORM_INDIKATORS_FAIL         =     "FORM_INDIKATORS_FAIL";
export const INDIKATORS_FAIL              =     "INDIKATORS_FAIL";
export const INDIKATOR_FAIL               =     "INDIKATOR_FAIL";